import Scene from "scenejs";

/**
 * Build a Scene instance from editor animations limited to the current view/contained view.
 * Returns null when there is nothing to animate.
 */
export function createAnimationScene(boxesById = {}, animationsById = {}, currentViewOrContained) {
  const keyframe = {};

  const animations = [];
  Object.keys(boxesById).forEach((key) => {
    if (
      boxesById[key].parent === currentViewOrContained &&
      animationsById[key] != null &&
      animationsById[key].length > 0
    ) {
      animations.push({ id: key, animations: animationsById[key] });
    }
  });

  if (animations.length === 0) {
    return null;
  }

  animations.forEach((anim) => {
    const boxId = `#box-${anim.id}`;
    keyframe[boxId] = {};

    anim.animations.forEach((animation) => {
      keyframe[boxId][animation.duration] = {
        left: animation.positionx,
        top: animation.positiony,
        opacity: animation.opacity,
        width: animation.width,
      };

      if (animation.height != null && animation.height !== "0%" && animation.height !== "0") {
        keyframe[boxId][animation.duration].height = animation.height;
      }
    });
  });

  return new Scene(keyframe, {
    selector: true,
    easing: "ease-in-out",
  });
}

/**
 * Reset DOM elements for boxes to their original position/size/opacity.
 */
export function resetAnimationPositions({
  boxesById = {},
  pluginToolbarsById = {},
  currentViewOrContained,
}) {
  Object.keys(pluginToolbarsById).forEach((key) => {
    const box = boxesById[key];
    const plugin = pluginToolbarsById[key];

    if (
      box != null &&
      plugin != null &&
      box.parent === currentViewOrContained &&
      document.getElementById(`box-${key}`) != null
    ) {
      const element = document.getElementById(`box-${key}`);
      element.style.opacity = 1;
      element.style.left = box.position.x;
      element.style.top = box.position.y;
      element.style.width =
        plugin.structure.width === "auto"
          ? plugin.structure.width
          : plugin.structure.width + plugin.structure.widthUnit;
      element.style.height =
        plugin.structure.height === "auto"
          ? plugin.structure.height
          : plugin.structure.height + plugin.structure.heightUnit;
    }
  });
}

/**
 * Interpolate two keyframes (position/size/opacity) directly on a DOM element.
 */
export function interpolateAnimationFrame(element, startKeyframe, endKeyframe, progress) {
  const interpolate = (start, end, pct) => {
    const startVal = parseFloat(start) || 0;
    const endVal = parseFloat(end) || 0;
    return startVal + (endVal - startVal) * pct;
  };

  if (startKeyframe.positionx !== undefined && endKeyframe.positionx !== undefined) {
    const currentX = interpolate(startKeyframe.positionx, endKeyframe.positionx, progress);
    element.style.left = `${currentX}%`;
  }

  if (startKeyframe.positiony !== undefined && endKeyframe.positiony !== undefined) {
    const currentY = interpolate(startKeyframe.positiony, endKeyframe.positiony, progress);
    element.style.top = `${currentY}%`;
  }

  if (startKeyframe.width !== undefined && endKeyframe.width !== undefined) {
    const currentWidth = interpolate(startKeyframe.width, endKeyframe.width, progress);
    element.style.width = `${currentWidth}%`;
  }

  if (startKeyframe.height !== undefined && endKeyframe.height !== undefined) {
    const currentHeight = interpolate(startKeyframe.height, endKeyframe.height, progress);
    element.style.height = `${currentHeight}%`;
  }

  if (startKeyframe.opacity !== undefined && endKeyframe.opacity !== undefined) {
    const currentOpacity = interpolate(startKeyframe.opacity, endKeyframe.opacity, progress);
    element.style.opacity = currentOpacity;
  }

  element.style.transition = "none";
}
